/**
 * @TODO: This model doesn't include all subscription
 * props fetched from the backend
 */
export class Subscription {
    public includedDevices: number;
    public allowedDevices: number;

    public constructor(data?: Subscription) {
        this.allowedDevices = (data && data.allowedDevices) ? data.allowedDevices : 0;
        this.includedDevices = (data && data.includedDevices) ? data.includedDevices : 0;
    }
}
